import { useSelector } from 'react-redux';

export function usePictureList() {
  const { media } = useSelector(({ finders }) => finders.finder.finderSettings);
  return media?.map(item => ({ label: item.originalFileName, value: item.id, image: item.s3Url }));
}
